import { Component, OnInit } from "@angular/core";
import { CrudComponent } from "src/app/components/shared/cruds/crud.component";
import { Condition } from "src/app/models/custom-types";
import { FilterEvent } from "src/app/models/filter";
import { ListColumn } from "src/app/models/list-columns.model";
import { TiposMaterialDTO } from "src/app/models/tipo-material.dto";
import { AlertasSwalService } from "src/app/services/alerts.service";
import { LayoutsService } from "src/app/services/layouts.service";
import { Filter } from "src/app/shared/classes/filter";
import { TipoMaterialesService } from "./tipos-materiales.service";
import { DrawerService } from "src/app/services/drawer.service";
import { TipoMaterialDrawerForm } from "./drawer-form/drawer-form.component";

@Component({
  selector: "app-tipos-materiales",
  templateUrl: "./tipos-materiales.component.html",
  styles: [],
})
export class TiposMaterialesComponent
  extends CrudComponent<TiposMaterialDTO>
  implements OnInit
{
  columnId: string = "IdTipoMaterial";
  public columns: ListColumn[] = [
    {
      name: "Descripcion",
      property: "Descripcion",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "actions",
      property: "actions",
      visible: true,
      isModelProperty: false,
    },
  ];
  filtro: string = "";
  inactivos: boolean = false;
  realdata: TiposMaterialDTO[];
  constructor(
    public service: TipoMaterialesService,
    private layoutService: LayoutsService,
    public alerts: AlertasSwalService,
    public drawer: DrawerService,
  ) {
    super(service, alerts);
  }

  ngOnInit(): void {
    this.Init();
    this.loadRecords();
    this.layoutService.changeHeader("Tipos de materiales");
    this.filter = new Filter<TiposMaterialDTO>(
      this.conditions,
      this.columns,
      true
    );
    this.filter.setColumnActive(this.columnActive);
  }

  loadRecords() {
    this.service.get().subscribe(
      (resultData) => {
        this.realdata = resultData;
        this.filter.setDataTable(this.realdata, this.tableComp);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }

  //#region Filter

  public filter: Filter<TiposMaterialDTO>;
  public conditions: Condition<TiposMaterialDTO> = {
    Descripcion: (o, f) =>
      (o.Descripcion ?? "").toLocaleLowerCase().indexOf(f) > -1,
  };

  filterdata(e: FilterEvent) {
    this.filter.filterdata(e, this.realdata, this.tableComp);
  }

  //#endregion Filter

  saveForm(e: { mode: string; value: any; file: File }) {
    if (e.mode == "create") {
      if (e.file) this.guardarConImagen(e.value, e.file);
      else this.guardar(e.value);
    } else if (e.mode == "update") {
      if (e.file) this.actualizarConImagen(e.value, e.file);
      else this.actualizar(e.value);
    }
  }

  guardarConImagen(row: any, imagen: File) {
    this.service.addWithFile(row, imagen).subscribe(
      (next) => {
        this.alerts.correcta("Creado", "Accion realizada correctamente");
        this.formulario.setStanby();
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }

  actualizarConImagen(row: any, imagen: File) {
    this.service.updateWithFile(row, imagen).subscribe(
      (next) => {
        this.alerts.correcta("Actualizado", "Accion realizada correctamente");
        this.formulario.setStanby();
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );
  }

  openUser() {
    const drawerRef = this.drawer.open({
      component: TipoMaterialDrawerForm,
      data: { mode: "create", value: {} },
      width: "500px",
      title: "Tipos de material",
      classes: "bg-blueGray-100",
      actions: [
        {
          label: "Cancel",
          action: () => this.drawer.close(),
          buttonClass: "bg-red-600",
        },
        {
          label: "Guardar",
          action: (component: TipoMaterialDrawerForm) => component.saveOver(),
        },
      ],
    });

    drawerRef.afterClosed$.subscribe((result: any) => {
      this.saveForm(result.data);
    });
  }

  override openEdit(value: any) {
    const drawerRef = this.drawer.open({
      component: TipoMaterialDrawerForm,
      data: { mode: "update", value: value },
      width: "500px",
      title: "Tipos de material",
      classes: "bg-blueGray-100",
      actions: [
        {
          label: "Cancel",
          action: () => this.drawer.close(),
          buttonClass: "bg-red-600",
        },
        {
          label: "Actualizar",
          action: (component: TipoMaterialDrawerForm) => component.saveOver(),
        },
      ],
    });

    drawerRef.afterClosed$.subscribe((result: any) => {
      this.saveForm(result.data);
    });
  }
  public tableActionsCC = [
    {
      label: "Nuevo",
      icon: "plus",
      className:
        "text-xs font-bold uppercase px-3 py-2 rounded shadow hover:shadow-md bg-blueGray-600 text-white disabled:opacity-50",
      action: () => this.openUser(),
    },
  ];
}
